// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__oTYY3","location":"Header_location__1Qexs"};